import type * as React from 'react';

import { useTranslation } from '@crehana/i18n';
import { CustomNextImage as Image } from '@crehana/next';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { type CuiTheme, InverseButton, Slider } from '@crehana/ui';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

import { MICRODEGREES } from './constants';

const CardWrapper = styled.div`
  width: 280px;
  height: 280px;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 418px;
    height: 260px;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    width: 23%;
    height: 260px;
  }
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border-radius: 32px;
    background: linear-gradient(
      0deg,
      #040817 1.45%,
      rgba(5, 10, 29, 0.566667) 40.41%,
      rgba(7, 14, 39, 0) 81.87%
    );
  }
`;

const MicrodegreeCard: React.FC<
  React.PropsWithChildren<{
    title: string;
    image: string;
    url: string;
  }>
> = ({ title, url, image }) => {
  const { t } = useTranslation();

  return (
    <CardWrapper className="relative items-center overflow-hidden">
      <Image
        css={`
          border-radius: 32px;
        `}
        layout="fill"
        objectFit="cover"
        alt={title}
        src={image}
      />
      <div className="absolute z-2 bottom-0 mb-32 text-center max-w-160 right-0 left-0 mr-auto ml-auto">
        <h6 className="font-subtitle3 text-white text-center mb-8">
          {t(title)}
        </h6>
        <InverseButton
          isDark
          as="a"
          href={url}
          label={t('SEE_MORE')}
          size="xs"
          white
        />
      </div>
    </CardWrapper>
  );
};

const Mobile = () => (
  <Slider
    itemsPerPage={{ xs: 1, sm: 1, md: 1, lg: 4 }}
    css=""
    desktopPaginationSelector=".microdegree-pagination"
    desktopPaginationType="dots"
    mobilePaginationProps={{
      type: 'dots',
    }}
    infinite
  >
    {MICRODEGREES.map((item, index) => (
      // biome-ignore lint/suspicious/noArrayIndexKey: legacy code - suspicious/noArrayIndexKey
      <MicrodegreeCard key={`pre-md-${index}`} {...item} />
    ))}
  </Slider>
);

const Desktop = () => (
  <div
    className="m-auto flex items-center justify-between"
    css={`
      width: 90%;
    `}
  >
    {MICRODEGREES.map((item, index) => (
      // biome-ignore lint/suspicious/noArrayIndexKey: legacy code - suspicious/noArrayIndexKey
      <MicrodegreeCard key={`pre-md-${index}`} {...item} />
    ))}
  </div>
);

const Microdegrees = () => {
  return (
    <div
      className="m-auto"
      css={`
        ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.down('sm')} {
          width: 280px;
        }
        ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('sm')} {
          width: 418px;
        }
        ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('lg')} {
          width: 100%;
        }
      `}
    >
      <div className="hidden lg:block">
        <Desktop />
      </div>
      <div className="lg:hidden">
        <Mobile />
      </div>
      <div className="flex flex-col items-center mt-48">
        <div className="microdegree-pagination " />
      </div>
    </div>
  );
};

export default Microdegrees;
